export default __webpack_public_path__ + "static/media/1240.916ad934.png";